import { render, staticRenderFns } from "./Page-Purchase.vue?vue&type=template&id=77083654&"
import script from "./Page-Purchase.vue?vue&type=script&lang=js&"
export * from "./Page-Purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports